import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { TranslateService } from './translate.service';

@Pipe({
  name: 'translate',
  pure: false,          // ✅ important with async
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  private lastKey?: string;
  private lastParamsJson?: string;
  private lastObs$?: Observable<string>;

  constructor(private translate: TranslateService) { }

  transform(key: string, params?: Record<string, any>): Observable<string> {
    const paramsJson = params ? JSON.stringify(params) : '';
    if (key !== this.lastKey || paramsJson !== this.lastParamsJson || !this.lastObs$) {
      // console.log('key key key', key);
      this.lastKey = key;
      this.lastParamsJson = paramsJson;
      this.lastObs$ = this.translate.get$(key, params)//.pipe(shareReplay(1));

      // this.lastObs$.subscribe(c => {
      //   console.log('key', this.lastKey, key, c);

      // })
    }
    return this.lastObs$;
  }
}
